'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var direction = {
        right: 0,
        left: 'auto'
    };

    if (this.props.dirLeft) {
        direction = {
            left: 0,
            right: 'auto'
        };
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            display: 'inline-block',
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            color: theme.color
        },
        button: {},
        buttonImg: {
            width: theme.gutter * 3 + 'px',
            height: theme.gutter * 3 + 'px',
            backgroundImage: 'url("' + theme.appearanceImage + '")',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            transition: 'background-image ' + theme.itemTransitionDuration + ' ' + theme.itemTransitionFunction
        },
        list: Object.assign({
            position: 'absolute',
            top: 'calc(100% + ' + theme.gutter / 2 + 'px)',
            background: theme.listBackground,
            boxShadow: theme.listBoxShadow,
            padding: theme.gutter + 'px 0',
            zIndex: theme.listZIndex
        }, direction),
        item: {
            color: theme.itemColor,
            backgroundColor: theme.itemBackground,
            transition: 'background ' + theme.itemTransitionDuration + ' ' + theme.itemTransitionFunction + ', color ' + theme.itemTransitionDuration + ' ' + theme.itemTransitionFunction,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            textAlign: 'left',
            cursor: 'pointer',

            '&:focus': {
                background: theme.focusItemBackground,
                color: theme.focusItemColor
            },

            '&:hover': {
                background: theme.hoverItemBackground,
                color: theme.hoverItemColor
            },

            '&:active': {
                background: theme.activeItemBackground,
                color: theme.activeItemColor
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        item: (0, _aphroditeJss.css)(styleList.item),
        list: (0, _aphroditeJss.css)(styleList.list),
        button: (0, _aphroditeJss.css)(styleList.button),
        buttonImg: (0, _aphroditeJss.css)(styleList.buttonImg)
    };
};

var _options = require('../img/options.svg');

var _options2 = _interopRequireDefault(_options);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        color: theme.tFilled,
        appearanceImage: _options2.default,

        listBackground: theme.elPrimary,
        listBoxShadow: '0 6px 10px 0 ' + theme.elShadow + ', 0 4px 10px 0 ' + theme.elShadow,
        listZIndex: theme.zOverlay,

        itemColor: theme.tFilled,
        itemBackground: 'transparent',
        itemTransitionFunction: theme.transitionFunction,
        itemTransitionDuration: theme.transitionDuration,

        focusItemColor: theme.tFilled,
        focusItemBackground: 'transparent',

        hoverItemColor: theme.tFilled,
        hoverItemBackground: theme.elLightest,

        activeItemColor: theme.tActive,
        activeItemBackground: theme.elLightest
    };
};